/// vistas
import HomeView from "../views/home/HomeView";
// iconos
import {ReactComponent as AdmindIcon} from "../assets/icons/user_star.svg";
import {ReactComponent as ComunityIcon} from "../assets/icons/people.svg";
import {ReactComponent as HomeIcon} from "../assets/icons/home.svg";
import {ReactComponent as OfferIcon} from "../assets/icons/class_online.svg";
import {ReactComponent as DomecqIcon} from "../assets/icons/student.svg";
import {ReactComponent as FacilitadorIcon} from "../assets/icons/facilitador.svg";
import AdminsView from "../views/admins/AdminsView";
import FacilitadoresView from "../views/facilitadores/FacilitadoresView";
import DomecAcademyView from "../views/domecqAcademy/DomecAcademyView";
import OfferView from "../views/offer/OfferView";
import EssentialCoursesView from "../views/essentialCourses/EssentialCoursesView";
import CertificatePrimeView from "../views/primeCertificate/CertificatePrimeView";
import EnterpriseProgramView from "../views/enterpriseProgram/EnterpriseProgramView";
import EmblemProgramView from "../views/emblemProgram/EmblemProgramView";
import CommunityView from "../views/community/CommunityView";
import UsersView from "../views/users/UsersView";
import OfferAdd from "../views/offerAdd/OfferAdd";
import OfferEdit from "../views/offerEdit/OfferEdit";
import PrimeEdit from "../views/primeEdit/PrimeEdit";

const RoutesList = [
   {
      path: "/users/list",
      name: "usuarios",
      back: "#95a5a6",
      false: true,
      exact: true,
      component: UsersView,
      title: "Usuarios registrados",
   },
   {
      path: "/users",
      icon: AdmindIcon,
      name: "administradores",
      back: "#536a82",
      nav: true,
      exact: true,
      component: AdminsView,
      title: "Lista de administradores",
   },
   {
      path: "/comunity",
      icon: ComunityIcon,
      back: "#2c3e50",
      name: "comunidad",
      nav: true,
      exact: true,
      component: UsersView,
      title: "lista de todos los usuarios",
   },
   {
      path: "/home",
      icon: HomeIcon,
      name: "home",
      back: "#c6b784",
      nav: true,
      exact: true,
      component: HomeView,
      title: "home",
   },
   {
      path: "/offer",
      icon: OfferIcon,
      name: "oferta académica",
      back: "#32529d",
      nav: true,
      exact: true,
      title: "domecq",
      component: OfferView,
   },
   {
      path: "/offer/edit/:type/:id",
      icon: OfferIcon,
      name: "oferta académica",
      back: "#32529d",
      nav: false,
      exact: true,
      title: "domecq",
      component: OfferEdit,
   },
   {
      path: "/offer/add/:type/",
      icon: OfferIcon,
      name: "cursos",
      back: "#af0069",
      nav: false,
      exact: true,
      title: "Editar Curso",
      component: OfferAdd,
   },
   {
      path: "/offer/masterclass/edit/:id",
      icon: OfferIcon,
      name: "cursos esenciales",
      back: "#8e44ad",
      nav: false,
      exact: true,
      title: "Editar Curso Esencial",
      component: PrimeEdit,
   },
   {
      path: "/offer/cursos_esenciales",
      icon: OfferIcon,
      name: "Cursos esenciales",
      back: "#af0069",
      nav: false,
      exact: true,
      title: "Cursos esenciales",
      component: EssentialCoursesView,
   },
   {
      path: "/offer/certificado_prime",
      icon: OfferIcon,
      name: "certificado prime",
      back: "#8e44ad",
      nav: false,
      exact: true,
      title: "certificado prime",
      component: CertificatePrimeView,
   },
   {
      path: "/offer/programa_emblem",
      icon: OfferIcon,
      name: "programa emblem",
      back: "#2980b9",
      nav: false,
      exact: true,
      title: "programa emblem",
      component: EmblemProgramView,
   },
   {
      path: "/offer/programa_enterprise",
      icon: OfferIcon,
      name: "programa enterprise",
      back: "#95afc0",
      nav: false,
      exact: true,
      title: "programa enterprise",
      component: EnterpriseProgramView,
   },
   {
      path: "/domecq_academy",
      icon: DomecqIcon,
      name: "domecq academy",
      back: "#9ec6c6",
      nav: true,
      exact: true,
      title: "Domecq academy",
      component: DomecAcademyView,
   },
   {
      path: "/facilitadores",
      icon: FacilitadorIcon,
      name: "facilitadores",
      back: "#cbc2c2",
      nav: true,
      exact: true,
      title: "facilitadores",
      component: FacilitadoresView,
   },
];

export default RoutesList;
